import { useMemo, useState } from "react";
import { Box, Checkbox, IconButton, List, ListItemButton, ListItemText, Paper, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AddProductPanel({ options, selectedIds, onToggle, onClose }) {
    const [searchText, setSearchText] = useState("");

    const filteredOptions = useMemo(() => {
        const text = searchText.trim().toLowerCase();
        if (!text) return options;
        return options.filter(
            (option) => option.name?.toLowerCase().includes(text) || option.id.toLowerCase().includes(text)
        );
    }, [options, searchText]);

    return (
        <Paper variant="outlined" sx={{ width: 320, flexShrink: 0, p: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Typography variant="subtitle1">Add Products</Typography>
                <IconButton size="small" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <TextField
                fullWidth
                size="small"
                placeholder="Search products"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                sx={{ mb: 1 }}
            />

            <List sx={{ maxHeight: 480, overflowY: "auto" }} dense>
                {filteredOptions.map((option) => {
                    const checked = selectedIds.has(option.id);
                    return (
                        <ListItemButton key={option.id} onClick={() => onToggle(option)}>
                            <Checkbox edge="start" checked={checked} tabIndex={-1} disableRipple size="small" />
                            <ListItemText primary={option.name} secondary={`#${option.id}`} />
                        </ListItemButton>
                    );
                })}

                {!filteredOptions.length && (
                    <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                        No products found.
                    </Typography>
                )}
            </List>
        </Paper>
    );
}
